import Empty from 'antd/es/empty';

/**
 * OpEmpty is a direct export of Ant Design's Empty component.
 * It displays a placeholder when there is no data to show.
 * 
 * Use this component to indicate empty states in lists, tables, search results, or any area
 * where data is expected but not available. Provides better UX than showing nothing.
 * 
 * @example
 * <OpEmpty description="No data available" />
 * <OpEmpty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No results found" />
 */
export const OpEmpty = Empty;
